import MyApplicationQueries from "../../../jsx/components/Dashboard/MyApplications/myapplicationqueries";

const MyApplicationQueriesWrapper = () => {
  return <MyApplicationQueries />;
};

export const allowedRoles = [_enum.ROUTE_PERSONAS.customer];
export default constore(MyApplicationQueriesWrapper);
